"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldAvatarCoreInputs = void 0;
const avatar_size_1 = require("./avatar.size");
class EmeraldAvatarCoreInputs {
    constructor() {
        this.iconColor = '#FFFFFF';
        this.initialsColor = '#FFFFFF';
        this.backgroundColor = '#003F2D';
        this.icon = 'person';
        this.size = avatar_size_1.EmeraldAvatarSize.medium;
        this.disabled = false;
        this.type = 'primary';
    }
}
exports.EmeraldAvatarCoreInputs = EmeraldAvatarCoreInputs;
//# sourceMappingURL=avatar.inputs.js.map